import { gql } from '@apollo/client';

/**
 * The volunteering opportunities a community offers, from the supporter org's side.
 * Read-only here — the roles themselves are authored by the community on /partnerships.
 */
export const GET_VOLUNTEER_ROLES = gql`
query VolunteerRoles($supportedOrganisationId: Int!) {
  volunteerRoles(supportedOrganisationId: $supportedOrganisationId) {
    id
    title
    type
    icon
    interestedCount
    interested {
      id
      expressedAt
      person { id name }
    }
  }
}`;
